import { render, staticRenderFns } from "./WhyUs.vue?vue&type=template&id=55ea4ede&scoped=true"
import script from "./WhyUs.vue?vue&type=script&lang=ts"
export * from "./WhyUs.vue?vue&type=script&lang=ts"
import style0 from "./WhyUs.vue?vue&type=style&index=0&id=55ea4ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea4ede",
  null
  
)

export default component.exports